<lib-generic-type-ahead-multiselect
    [isReadOnly]="isReadOnly"
    [source]="contactItems"
    [selectedItems]="selectedContactItems"
    [config]="{
        defaultText: 'Select',
        itemDisplayKey: 'fullName',
        itemTemplate: contactTemplate
    }"
    removeKey="contactId"
    (textChange)="onContactTextChange($event)"
    (selectedItemsChange)="onSelectedContactChange($event)"
    (removeItemChange)="onRemoveContactChange($event)"
    [isReadOnly]="isReadOnly"
    [action]="addContactAction"
    [placeholder]="(isReadOnly && !bindingProperty) || !label ? 'Select an Item' : 'Add ' + label"
>
</lib-generic-type-ahead-multiselect>

<ng-template #contactTemplate let-data>
    <div>
        <span
            [innerHTML]="
                $safeNavigationMigration(data.object?.firstName) + ' ' + $safeNavigationMigration(data.object?.lastName)
                    | highlightText: data.inputText
            "
        ></span>
        @if (data.object?.companyName) {
            <div>
                <span
                    [innerHTML]="$safeNavigationMigration(data.object?.companyName) | highlightText: data.inputText"
                ></span>
                @if (data.object?.isMain) {
                    <span> - Main contact</span>
                }
            </div>
        }
        @if (!data.object?.companyName) {
            <div>
                @if (!data.object?.companyName) {
                    <span>No company assigned</span>
                }
            </div>
        }
    </div>
</ng-template>
